import decode from 'jwt-decode';
import moment from 'moment'
export default class URLService {
    // Initializing important variables
    constructor(domain) {
    }
    getUrl(){
      var loc = window.location;
      var url = new URL(loc)
      var enviorment_url = url.hostname
      if(enviorment_url == "booking-staging.getspiffy.com"){
        return "https://staging.getspiffy.com/"
      }
      else if(enviorment_url == "booking.getspiffy.com"){
        return "https://my.getspiffy.com/"
      }
      else {
        return "http://localhost:3000/"
      }
    }

    getConsumerWebUrl(){
      var loc = window.location;
      var url = new URL(loc)
      var enviorment_url = url.hostname
      console.log("URL:" + enviorment_url)
      return enviorment_url + '/'
    }
}



// WEBPACK FOOTER //
// ./src/utils/URLService.js